import { render, staticRenderFns } from "./FormatStructureTranslationTool.vue?vue&type=template&id=29b42b22&scoped=true&"
import script from "./FormatStructureTranslationTool.vue?vue&type=script&lang=ts&"
export * from "./FormatStructureTranslationTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatStructureTranslationTool.vue?vue&type=style&index=0&id=29b42b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b42b22",
  null
  
)

export default component.exports